import { Component, Inject, OnInit, ViewChild } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

import { MatPaginator } from '@angular/material/paginator';

import { MatSnackBar } from '@angular/material/snack-bar';

import { MatSort } from '@angular/material/sort';

import { MatTableDataSource } from '@angular/material/table';

import { MatDatepickerModule } from '@angular/material/datepicker';

import { MatNativeDateModule } from '@angular/material/core';

import { CustomerBills } from 'src/app/model/customerbills.model';

import { Employee } from 'src/app/model/employee.model';

import { ApiService } from 'src/app/services/api.service';

import {formatDate} from '@angular/common';

import { Complaint } from 'src/app/model/complaint';

import { AddcomplaintComponent } from '../addcomplaint/addcomplaint.component';

import { AreaFilterService } from 'src/app/services/area-filter.service';





@Component({

  selector: 'app-viewcomplaints',

  templateUrl: './viewcomplaints.component.html',

  styleUrls: ['./viewcomplaints.component.scss']

})

export class ViewcomplaintsComponent implements OnInit {



     displayedColumns: string[] = ['complaintId', 'customerId','customerName','customerAddress','customerPhone','dateLogged', 'status','engineerRequired','description','selectedAreaId','selectedArea','engineerId','engineerName','engineerPhone','resolvedDate','resolvedStatus','remarks','loggedUser','resolvedBy','actions'];

     columnNames :string[]=['Complaint Id', 'Customer Id','Customer Name','Customer Address','Customer Phone','Date Logged', 'Status','Engineer Required','Description','Selected Area Id','Selected Area','Engineer Id','Engineer Name','Engineer Phone','Resolved Date','Resolved Status','Resolved Remarks','Logged User','Resolved By'];

    dataSource = new MatTableDataSource<Complaint>(null);

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    complaintData:Complaint[] = [];
    allComplaints: Complaint[] = [];
    filteredComplaints: Complaint[] = [];
    isLoading : boolean = false;

  // Client-side pagination properties
  pageSize: number = 10;
  totalElements: number = 0;
  pageSizes = [10, 25, 50, 100];

  // Search properties
  selectedSearchOption: number = 0;
  searchValue: string = '';
  enableSearchButton: boolean = false;
  fromDate: Date = null;
  toDate: Date = null;
  searchTriggered: boolean = false;

     optionList = [
    { key: 1, name: 'Complaint ID', value: 'complaintId' },
    { key: 2, name: 'Customer ID', value: 'customerId' },
    { key: 3, name: 'Customer Name', value: 'customerName' },
    { key: 4, name: 'Customer Address', value: 'customerAddress' },
    { key: 5, name: 'Customer Phone', value: 'customerPhone' },
    { key: 6, name: 'Status', value: 'status' },
    { key: 7, name: 'Engineer Required', value: 'engineerRequired' },
    { key: 8, name: 'Selected Area', value: 'selectedArea' },
    { key: 9, name: 'Engineer Name', value: 'engineerName' },
    { key: 10, name: 'Resolved Status', value: 'resolvedStatus' }
  ];

    constructor(

      private apiService: ApiService,

      private _snackBar: MatSnackBar,

      private dialog: MatDialog,

      private areaFilterService: AreaFilterService,

      public dialogRef: MatDialogRef<ViewcomplaintsComponent>) {

        this.isLoading=true;

     this.loadComplaints();

    }



    themeSelected: string = "light";

    selectedComplaint: Complaint | null = null;

    showPrintTable: boolean = false;

    remarks: string = "";



    

    ngOnInit(): void {

       this.themeSelected = localStorage.getItem("theme") ? localStorage.getItem("theme"):"dark";

    }

    ngAfterViewInit(): void {
      // Listen to paginator changes to update complaintData for print
      if (this.paginator) {
        this.paginator.page.subscribe(() => {
          this.updateComplaintDataForPrint();
        });
      }
    }

    private updateComplaintDataForPrint(): void {
      if (this.paginator && this.filteredComplaints) {
        const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
        const endIndex = startIndex + this.paginator.pageSize;
        this.complaintData = this.filteredComplaints.slice(startIndex, endIndex);
      }
    }



    close(): void {
      this.remarks = "";
      this.selectedComplaint = null;
    }



    loadComplaints(){

      this.isLoading = true;

      this.apiService.getComplaints(0, 50000, '')

        .subscribe(data => {

          if(data && data.content){

            this.allComplaints = data.content.map((complaint : Complaint)=>{

              complaint.dateLogged =  complaint.dateLogged &&  complaint.dateLogged.replace("T"," ");

              complaint.resolvedDate = complaint.resolvedDate && complaint.resolvedDate.replace("T"," ");

              return complaint;

            });

            // Restrict to the logged-in user's areas
            this.allComplaints = this.areaFilterService.filterComplaintsByArea(this.allComplaints);

            // Initialize filtered complaints with all data
            this.filteredComplaints = [...this.allComplaints];
            
            // Update pagination info
            this.totalElements = this.filteredComplaints.length;
            
            // Apply pagination to display data
            this.updatePaginatedData();

          }

          this.isLoading=false;

      });

    }

     



  applyFilter(filterValue: string) {

    this.dataSource.filter = filterValue.trim().toLowerCase();

    this.complaintData = this.dataSource.filteredData;

  }



  printComplaintsDialog(){
    console.log('Print Complaints Dialog method called');
    console.log('Current showPrintTable value:', this.showPrintTable);
    console.log('Current complaintData length:', this.complaintData?.length || 0);
    
    this.showPrintTable = !this.showPrintTable;
    console.log('New showPrintTable value:', this.showPrintTable);
    
    // Angular's *ngIf will handle showing/hiding the print table
    // We just need to toggle the main complaints list visibility
    setTimeout(() => {
      if(this.showPrintTable){
        // Hide main complaints list when print view is shown
        const complaintsListElement = document.getElementById("complaintsList");
        if (complaintsListElement) {
          complaintsListElement.style.display="none";
          console.log('Hidden complaints list');
        } else {
          console.error('complaintsList element not found');
        }
      } else {
        // Show main complaints list when print view is hidden
        const complaintsListElement = document.getElementById("complaintsList");
        if (complaintsListElement) {
          complaintsListElement.style.display="block";
          console.log('Shown complaints list');
        } else {
          console.error('complaintsList element not found');
        }
      }
    }, 0);
  }



  printDueBills(){
    console.log('Print Due Bills method called');
    
    // Check if printDueBills element exists
    const printElement = document.getElementById("printDueBills");
    if (!printElement) {
      console.error('Print element not found');
      return;
    }
    
    let popupWinindow;
    let innerContents = printElement.innerHTML;

    console.log('Print contents length:', innerContents.length);

    popupWinindow = window.open('', '_blank', 'scrollbars=yes,menubar=no,toolbar=no,location=no,status=no,titlebar=no');

    if (!popupWinindow) {
      console.error('Popup blocked by browser');
      return;
    }

    popupWinindow.document.open();

    popupWinindow.document.write('<html><head><link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" integrity="sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm" crossorigin="anonymous"><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()"><div class="customerDueBills">' + innerContents + '</div></html>');

    popupWinindow.document.close();

    console.log('Print window created successfully');
  }



  openEditComplaintDialog(complaint: Complaint): void {

    if (complaint.resolvedStatus === 'Resolved') {

      return;

    }



    const dialogRef = this.dialog.open(AddcomplaintComponent, {

      width: '900px',

      data: { ...complaint }

    });



    dialogRef.afterClosed().subscribe(result => {

      // After editing, refresh the complaints list so changes are visible

      this.loadComplaints();

    });

  }



  resolveComplaint(complaint : Complaint){



    let dateUtc = new Date();



    // Convert to UTC+3 by adding 3 hours to the UTC time

    dateUtc.setUTCHours(dateUtc.getUTCHours() + 3);



    // Store the adjusted date in ISO format (without milliseconds)

    let resolvedDate = dateUtc.toISOString().split('.')[0]; 



    complaint.resolvedDate = resolvedDate;

    complaint.dateLogged = complaint.dateLogged.replace(" ","T");

    complaint.resolvedStatus="Resolved";

    complaint.remarks = this.remarks;



    const resolverId = localStorage.getItem('loggedInUser');

    const resolverName = localStorage.getItem('loggedInUserName');

    complaint.resolvedBy = resolverName || resolverId || 'Unknown';



    this.apiService.resolveComplaint(complaint)

    .subscribe(data => {

      if (data.isSuccess) {

        this._snackBar.open('Complaint Resolved successfully', 'Close', {

          duration: 3000

        });

      }

    });

  }

  validateSearch(): void {
    // Simple validation - enable search if there's any text
    this.enableSearchButton = this.searchValue.trim() !== '';
  }

  onDateChange(): void {
    this.validateSearch();
  }

  searchComplaints(): void {
    if (!this.enableSearchButton) return;

    this.isLoading = true;
    this.searchTriggered = true;
    
    // Client-side filtering
    this.filterComplaints();
  }

  private filterComplaints(): void {
    if (!this.searchValue.trim()) {
      this.filteredComplaints = [...this.allComplaints];
    } else {
      const searchTerm = this.searchValue.toLowerCase().trim();
      const selectedField = this.optionList.find(opt => opt.key === this.selectedSearchOption)?.value || '';
      
      this.filteredComplaints = this.allComplaints.filter(complaint => {
        if (selectedField && selectedField !== '') {
          // Search in specific field
          const fieldValue = complaint[selectedField];
          return fieldValue && fieldValue.toString().toLowerCase().includes(searchTerm);
        } else {
          // Search in all fields
          return Object.values(complaint).some(value => 
            value && value.toString().toLowerCase().includes(searchTerm)
          );
        }
      });
    }
    
    // Update pagination info
    this.totalElements = this.filteredComplaints.length;
    
    // Update displayed data
    this.updatePaginatedData();
    this.isLoading = false;
  }

  private updatePaginatedData(): void {
    // Set the filtered data as the data source for Material paginator
    this.dataSource = new MatTableDataSource<Complaint>(this.filteredComplaints);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    
    // Update complaintData for print functionality with current page data
    const startIndex = this.paginator ? this.paginator.pageIndex * this.paginator.pageSize : 0;
    const endIndex = startIndex + (this.paginator ? this.paginator.pageSize : this.pageSize);
    this.complaintData = this.filteredComplaints.slice(startIndex, endIndex);
  }

  
  
  clearSearch(): void {
    this.searchValue = '';
    this.enableSearchButton = false;
    this.searchTriggered = false;
    
    // Reset to all data
    this.filteredComplaints = [...this.allComplaints];
    this.totalElements = this.filteredComplaints.length;
    
    // Update displayed data
    this.updatePaginatedData();
    this.isLoading = false;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }




}


